import { Col, Row, Select, Space, Table, Typography } from "antd";
import { SearchInput } from "components/Shared/SearchInput";
import { useArrayDropdown } from "hooks/useArrayDropdown";
import { useSportConfiguration } from "hooks/useSportConfiguration";
import { useState } from "react";
import { useIntl } from "react-intl";

const DefaultStatusOptionValue = "DEFAULT";

type Props = {
  title?: string;
  isLoading: boolean;
  fixtures: Array<any>;
  columns: Array<any>;
};

export const FixtureTable = ({ title, isLoading, fixtures, columns }: Props) => {
  const { formatMessage } = useIntl();
  const [currentStatus, setCurrentStatus] = useState("DEFAULT");
  const [searchText, setSearchText] = useState("");
  const defaultOption = {
    label: formatMessage({ id: "select.fixtureStatus.defaultOption.label" }),
    value: DefaultStatusOptionValue,
  };
  const { configuration } = useSportConfiguration();
  const dropDownStatuses = useArrayDropdown(configuration.fixtureStatuses, "fixtureStatus", false);
  const options = [defaultOption, ...dropDownStatuses];

  const filteredFixtures = fixtures
    ?.filter((x) => (currentStatus !== DefaultStatusOptionValue ? x?.status === currentStatus : true))
    ?.filter(
      (fixture) =>
        fixture?.homeEntity?.nameLocal?.toLowerCase().indexOf(searchText?.toLowerCase()) > -1 ||
        fixture?.awayEntity?.nameLocal?.toLowerCase().indexOf(searchText?.toLowerCase()) > -1 ||
        fixture?.round?.toString()?.toLowerCase().indexOf(searchText?.toLowerCase()) > -1
    );

  return (
    <>
      <Row justify="space-between" align="middle">
        <Typography.Title level={5}>{title ?? "\u00A0"}</Typography.Title>
        <Space align="center">
          <Select
            popupMatchSelectWidth={false}
            variant="borderless"
            defaultValue={DefaultStatusOptionValue}
            onChange={setCurrentStatus}
            options={options}
          />
          <SearchInput onSearch={setSearchText} />
        </Space>
      </Row>
      <Row className="mb-15">
        <Col span={24}>
          <Table
            size="small"
            loading={isLoading}
            dataSource={filteredFixtures}
            rowKey="fixtureId"
            columns={columns as any}
            pagination={false}
          />
        </Col>
      </Row>
    </>
  );
};
